module.exports = __webpack_public_path__ + "static/img/downloadapp.44311f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadapp.png
// module id = f89U
// module chunks = 1